<footer class="isa-footer">

  <!-- Gradient top border -->
  <div class="footer-gradient-top"></div>

  <!-- Main Content Grid -->
  <div class="footer-grid">

    <!-- ═══ BRAND ═══ -->
    <div class="footer-brand">
      <a class="footer-logo" [routerLink]="'/home'">
        <div class="footer-logo-icon">
          <img src="assets/ISA-logo.png" alt="ISA" style="width:28px;height:28px;object-fit:contain;"
            onerror="this.style.display='none'">
        </div>
        <div class="footer-logo-text">
          <span class="footer-logo-name">ISA Connect</span>
          <span class="footer-logo-subtitle">INDOTECH SOFTWARE ASSOCIATION</span>
        </div>
      </a>

      <p class="footer-tagline">
        The definitive ecosystem for Indore's IT Founders, CXOs, and Tech Leaders.
        Fostering innovation, policy advocacy, and resource sharing to accelerate growth.
      </p>

      <!-- Social Links -->
      <div class="footer-socials">
        <a href="https://linkedin.com" target="_blank" class="social-btn" title="LinkedIn">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path
              d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
          </svg>
        </a>
        <a href="https://twitter.com" target="_blank" class="social-btn" title="Twitter / X">
          <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
            <path
              d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.261 5.632zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        </a>
        <a href="https://facebook.com" target="_blank" class="social-btn" title="Facebook">
          <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
            <path
              d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        </a>
        <a href="https://instagram.com" target="_blank" class="social-btn" title="Instagram">
          <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
            <path
              d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
          </svg>
        </a>
        <a href="https://youtube.com" target="_blank" class="social-btn" title="YouTube">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path
              d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
          </svg>
        </a>
      </div>
    </div>

    <!-- ═══ QUICK LINKS ═══ -->
    <div>
      <h4 class="footer-col-title">Quick Links</h4>
      <ul class="footer-links">
        <li *ngFor="let link of quickLinks">
          <span (click)="go(link.path)">{{ link.label }}</span>
        </li>
      </ul>
    </div>

    <!-- ═══ MEMBERSHIP ═══ -->
    <div>
      <h4 class="footer-col-title">Membership</h4>
      <ul class="footer-links">
        <li *ngFor="let link of memberLinks">
          <span (click)="go(link.path)">{{ link.label }}</span>
        </li>
      </ul>
    </div>

    <!-- ═══ CONTACT ═══ -->
    <div>
      <h4 class="footer-col-title">Get in Touch</h4>
      <div class="footer-contact-card">
        <div class="contact-item">
          <div class="contact-icon">📍</div>
          <div class="contact-text">
            <span class="contact-label">Address</span>
            <span class="contact-value">4th Floor, B Zone Business Spaces, Nipania Main Road, Dewas Naka, Pipliya Kumar, Indore, Madhya Pradesh, India</span>
            <!--<span class="contact-value">Brilliant Convention Centre, Indore, MP</span>-->
          </div>
        </div>
        <div class="contact-item">
          <div class="contact-icon">✉️</div>
          <div class="contact-text">
            <span class="contact-label">Email</span>
            <a href="mailto:info@theisa.in" class="contact-value"
              style="color:#818cf8;text-decoration:none">info&#64;theisa.in</a>
          </div>
        </div>
        <div class="contact-item">
          <div class="contact-icon">📞</div>
          <div class="contact-text">
            <span class="contact-label">Phone</span>
            <span class="contact-value">+91 56565 65656</span>
          </div>
        </div>
        <div class="contact-item">
          <div class="contact-icon">🕐</div>
          <div class="contact-text">
            <span class="contact-label">Office Hours</span>
            <span class="contact-value">24*7 Open</span>
            <span class="contact-value">Sunday Closed</span>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- ═══ BOTTOM BAR ═══ -->
  <div class="footer-bottom">
    <p class="footer-copy">
      &copy; {{ currentYear }} <span>INDOTECH SOFTWARE ASSOCIATION</span>. All rights reserved.
    </p>
    <div class="footer-badges">
      <a class="footer-badge" [routerLink]="'/privacy'">Privacy Policy</a>
      <a class="footer-badge" [routerLink]="'/terms'">Terms of Use</a>
      <a class="footer-badge" [routerLink]="'/refund'">Refund Policy</a>
      <span class="footer-badge">Made with ❤️ in Indore</span>
    </div>
  </div>

</footer>